import { render, staticRenderFns } from "./LogoutSidebar.vue?vue&type=template&id=5c1bf0c5&scoped=true&"
import script from "./LogoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./LogoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutSidebar.vue?vue&type=style&index=0&id=5c1bf0c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1bf0c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
